// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CopyUserPermissionsForm__wrapper__18N60","submitResult":"CopyUserPermissionsForm__submitResult__3yBSm","actionWrapper":"CopyUserPermissionsForm__actionWrapper__1I2SR","wrapper2faOptions":"CopyUserPermissionsForm__wrapper2faOptions__eVKLl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CopyUserPermissionsForm/CopyUserPermissionsForm.css
// module id = 2937
// module chunks = 0